/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Actions_Back_To_ChatInputs */

const es_settings_actions_back_to_chat = /** @type {(inputs: Settings_Actions_Back_To_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al chat`)
};

const en_settings_actions_back_to_chat = /** @type {(inputs: Settings_Actions_Back_To_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to chat`)
};

/**
* | output |
* | --- |
* | "Back to chat" |
*
* @param {Settings_Actions_Back_To_ChatInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_actions_back_to_chat = /** @type {((inputs?: Settings_Actions_Back_To_ChatInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Actions_Back_To_ChatInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_actions_back_to_chat(inputs)
	return en_settings_actions_back_to_chat(inputs)
});
export { settings_actions_back_to_chat as "settings.actions.back_to_chat" }